
    import { Component, Vue } from 'vue-property-decorator';
    import BaseVue from '@/components/BaseVue'

    @Component
    export default class Login extends BaseVue {

        private showPassword = false
        private userId = ""
        private password = ""
        private showMessage = false
        private message = ""

        // == イベント == //
        //ログインボタンの押下イベント
        private async LoginClick() {
            this.avoidMultipost(async () => {
                try {
                    const data = {
                        userId: this.userId,
                        password: this.password
                    };

                    const response = await this.$axios.post('api/Login', data)

                    if (response.data.messageData.messageList.length > 0) {
                        this.showMessage = true
                        this.message = response.data.messageData.messageList[0]
                        return
                    }
                    //ログインユーザー権限を設定
                    this.$store.dispatch('setRole', response.data.authority)
                    localStorage.setItem('userRoles', JSON.stringify(response.data.authority));
                    //トークン設定
                    this.$store.dispatch("auth", { userId: this.userId, userToken: response.data.token })

                    this.$router.push({ name: 'Menu' });

                } catch (e) {
                    console.log(e.message)
                }
            });
        }
    }
